import axios from 'axios'
import qs from 'qs'
import {Message} from 'element-ui';
import router from '../router';  // 确保正确导入你的 router 实例

const instance = axios.create({
    withCredentials: true,
    paramsSerializer: function (params) {
        return qs.stringify(params, {arrayFormat: 'repeat'})
    }
})

// 获取token的函数（假设）
function getToken() {
    // 此处应该从例如localStorage、cookie等处获取存储的token
    return localStorage.getItem('token');
}

// 重定向到登录页的函数（假设）
function redirectToLogin() {
    router.push({ path: '/login' });//登录页的路由为'/login'
}

/*instance.interceptors.request.use(async function (config) {
    return config
}, function (error) {
    return Promise.reject(error)
})*/

// 请求拦截器
instance.interceptors.request.use(
    config => {
        // 判断请求的 URL 是否是 file/download
        if (!config.url.includes('file/download')) {
            const token = getToken();
            if (token) {
                config.headers['Authorization'] = 'Bearer ' + token; // 将token设置在请求头中
            }
        }
        return config;
    },
    error => {
        // 对请求错误做些什么
        return Promise.reject(error);
    }
);

instance.interceptors.response.use(function (response) {
    if (response.data) {
        return response.data
    }
    return response
}, function (error) {
    if (error.response) {
        // 检查响应状态码，如果是401，则跳转到登录页
        if (error.response.status === 401) {
            redirectToLogin();
        }
       /* if (error.response.status === 401) {
            document.location.reload()
        } */else if (error.response.data && error.response.data.message) {
            Message.error(error.response.data.message)
        } else {
            Message.error('请求出错：' + error)
        }
    } else {
        Message.error('请求出错：' + error)
    }
    return Promise.reject(error)
})

export default instance
